import PlatformTechTypes from 'store/actionTypes/platformTech'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  list: [],
  pagination: {},
  systems: [],
  current: {}
}

const platformTech = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case PlatformTechTypes.GET_PLATFORM_TECH_SUCCESS:
      return {
        ...state,
        list: payload?.items,
        pagination: payload?.meta
      }
    case PlatformTechTypes.GET_PLATFORM_TECH_DETAIL_SUCCESS:
      return { ...state, current: payload }
    case PlatformTechTypes.GET_SYSTEM_PLATFORM_TECHS_SUCCESS:
      return { ...state, systems: payload?.items }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default platformTech
